/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class UrlWhitelistHandlerService {
  match(url: string, whitelistUrl: string | RegExp | (string | RegExp)[]): boolean {
    if (!Array.isArray(whitelistUrl)) {
      whitelistUrl = [whitelistUrl]
    }

    return whitelistUrl.some((whitelistedUrl) => {
      if (whitelistedUrl instanceof RegExp) {
        return url.match(whitelistedUrl) !== null
      }

      return url.startsWith(whitelistedUrl)
    })
  }
}
